import { Box, Flex, Text } from "@chakra-ui/react";
import type { ReactNode } from "react";

interface DrawerNavItemProps {
  icon: ReactNode;
  name: string;
  description?: string;
  to: string;
  isActive: boolean;
  onNavigate: (to: string) => void;
  badge?: number;
  badgeColor?: string;
}

export function DrawerNavItem({
  icon,
  name,
  description,
  to,
  isActive,
  onNavigate,
  badge,
  badgeColor = "#DC2626",
}: DrawerNavItemProps) {
  return (
    <Box position="relative" w="full">
      {isActive && (
        <Box
          position="absolute"
          left="0.3rem"
          top="50%"
          transform="translateY(-50%)"
          w="3px"
          h="1.4rem"
          rounded="full"
          bg="primary.surface.default"
        />
      )}

      <Flex
        pl={isActive ? "1.1rem" : "0.95rem"}
        pr="0.95rem"
        py={description ? "0.78rem" : "0.9rem"}
        w="full"
        rounded="0.85rem"
        alignItems="center"
        gap="0.75rem"
        cursor="pointer"
        color={isActive ? "greyscale.text.title" : "greyscale.text.body"}
        bg={isActive ? "rgba(34,197,94,0.08)" : "transparent"}
        border="1px solid"
        borderColor={isActive ? "rgba(34,197,94,0.18)" : "transparent"}
        _hover={{
          bg: isActive ? "rgba(34,197,94,0.12)" : "rgba(34,197,94,0.06)",
          borderColor: "rgba(34,197,94,0.16)",
          color: "greyscale.text.title",
          transform: "translateX(2px)",
          boxShadow: "0 6px 14px rgba(15,23,42,0.04)",
        }}
        transition="all 0.18s ease"
        onClick={() => onNavigate(to)}
      >
        <Box position="relative" flexShrink={0}>
          <Flex
            w="1.55rem"
            h="1.55rem"
            align="center"
            justify="center"
            color={isActive ? "primary.surface.default" : "greyscale.text.body"}
          >
            {icon}
          </Flex>
          {badge != null && badge > 0 && (
            <Box
              position="absolute"
              top="-0.55rem"
              right="-0.65rem"
              w="1.1rem"
              h="1.1rem"
              rounded="full"
              bg={badgeColor}
              color="white"
              display="flex"
              alignItems="center"
              justifyContent="center"
              fontSize="0.58rem"
              fontWeight="900"
              lineHeight="1"
              border="1.5px solid white"
            >
              {badge}
            </Box>
          )}
        </Box>
        <Box minW={0}>
          <Text
            textStyle={isActive ? "bodyRegular.strong" : "bodyRegular.base"}
            lineHeight="1.25"
          >
            {name}
          </Text>
          {description && (
            <Text
              mt="0.12rem"
              fontSize="0.75rem"
              fontWeight="500"
              color="greyscale.text.body"
              lineHeight="1.35"
            >
              {description}
            </Text>
          )}
        </Box>
      </Flex>
    </Box>
  );
}
